var _rect, _path, _rect2, _rect3, _path2, _polygon, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCiscoPlusBareMetal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 41.25,
    width: 12,
    height: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,60.75H56a.7502.7502,0,0,0,.75-.75V24a.7502.7502,0,0,0-.75-.75H24a.7502.7502,0,0,0-.75.75V60A.7502.7502,0,0,0,24,60.75Zm.75-36h30.5v10.5H24.75Zm0,12h30.5v10.5H24.75Zm0,12h30.5v10.5H24.75Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 53.25,
    width: 12,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 29.25,
    width: 12,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19.25a.7502.7502,0,0,0-.75.75V64a.7502.7502,0,0,0,.75.75H39.25V72h1.5V64.75H60a.7502.7502,0,0,0,.75-.75V20a.7502.7502,0,0,0-.75-.75H40.75V11.81055l2.71973,2.71972,1.06054-1.06054-4-4a.74972.74972,0,0,0-1.06054,0l-4,4,1.06054,1.06054L39.25,11.81055V19.25Zm39.25,1.5v42.5H20.75V20.75Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "72 11.25 68.75 11.25 68.75 8 67.25 8 67.25 11.25 64 11.25 64 12.75 67.25 12.75 67.25 16 68.75 16 68.75 12.75 72 12.75 72 11.25"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 30,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 30,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 42,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 42,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 42,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 54,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 54,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 54,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiscoPlusBareMetal);
export default __webpack_public_path__ + "static/media/icon_cisco_plus_bare_metal.fee1869b8ac60d013534d6da4811d6b4.svg";
export { ForwardRef as ReactComponent };